import { type SupportedLocale } from '@frameio/graphql-client/generated';

const SUPPORTED_LOCALES: readonly SupportedLocale[] = [
  'DE_DE',
  'EN_US',
  'ES_ES',
  'FR_FR',
  'IT_IT',
  'JA_JP',
  'KO_KR',
  'PT_BR',
  'RU_RU',
  'ZH_CN',
] as const;

export const DEFAULT_SUPPORTED_LOCALE: SupportedLocale = 'EN_US';

/**
 * Converts locale string from i18n format (e.g., 'en-US') to GraphQL SupportedLocale enum format (e.g., 'EN_US').
 * Returns undefined if the locale is not a supported massdriver locale.
 */
export function toSupportedLocale(locale: string): SupportedLocale | undefined {
  const converted = locale.replace('-', '_').toUpperCase();
  return SUPPORTED_LOCALES.includes(converted as SupportedLocale)
    ? (converted as SupportedLocale)
    : undefined;
}

/**
 * Converts locale to SupportedLocale and falls back to EN_US when unsupported.
 */
export function toSupportedLocaleOrDefault(locale: string): SupportedLocale {
  return toSupportedLocale(locale) ?? DEFAULT_SUPPORTED_LOCALE;
}
